import React from "react";

const BackButton = ({ id, name, onClick, label, icon }) => {
  return (
    <>
      <button
        id={id}
        name={name}
        onClick={onClick}
        className=" font-lato px-5 py-[0.7rem]  flex items-center justify-center gap-[0.2rem]
       text-center border-2 border-white border-solid bg-white transition-all text-secondary-color active:bg-[#e6ebed] 
      ease-in-out duration-200 hover:bg-[#9bb1b6] rounded-[0.675rem]"
      >
        <img src={icon} alt="plus icon" className="w-[1.5rem] h-[1.5rem]" />
        {label}
      </button>
    </>
  );
};

export default BackButton;
